import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 14,
	viewBox: "0 0 16 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.8438 6.65625L11.3438 2.15625C11.1562 1.96875 10.8125 1.96875 10.625 2.15625C10.4375 2.34375 10.4375 2.6875 10.625 2.875L14.2812 6.5H5.5C5.21875 6.5 5 6.75 5 7C5 7.28125 5.21875 7.5 5.5 7.5H14.2812L10.625 11.1562C10.4375 11.3438 10.4375 11.6875 10.625 11.875C10.8125 12.0625 11.1562 12.0625 11.3438 11.875L15.8438 7.375C15.9375 7.28125 16 7.15625 16 7C16 6.875 15.9375 6.75 15.8438 6.65625ZM5.5 13H2.5C1.65625 13 1 12.3438 1 11.5V2.5C1 1.6875 1.65625 1 2.5 1H5.5C5.75 1 6 0.78125 6 0.5C6 0.25 5.75 0 5.5 0H2.5C1.09375 0 0 1.125 0 2.5V11.5C0 12.9062 1.09375 14 2.5 14H5.5C5.75 14 6 13.7812 6 13.5C6 13.25 5.75 13 5.5 13Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
